import { SVGUniqueID } from './svg-unique-id';
import type { IconProps } from './types';
const Icon = (props: IconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    width={props.size || 24}
    height={props.size || 24}
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M21.1667 4H3V7.15943H21.1667V4ZM6.94975 7.94936H3.00046V11.1088H6.94975V7.94936ZM7.74001 7.94936H11.6893V11.1088H7.74001V7.94936ZM21.1674 7.94936H17.2181V11.1088H21.1674V7.94936ZM17.2181 11.8987H21.1674V15.0581H17.2181V11.8987ZM16.4278 11.8987H12.4785V15.0581H16.4278V11.8987ZM7.74001 11.8987H11.6893V15.0581H7.74001V11.8987ZM6.94975 15.8479H3.00046V19.0073H6.94975V15.8479ZM7.74001 15.8479H11.6893V19.0073H7.74001V15.8479ZM16.4278 15.8479H12.4785V19.0073H16.4278V15.8479ZM17.2181 15.8479H21.1674V19.0073H17.2181V15.8479ZM12.478 7.79131H16.4273V10.9507H12.478V7.79131ZM3 11.7407H6.94928V14.9001H3V11.7407Z"
      fill={props.color || 'currentColor'}
    />
  </svg>
);
const SvgDataTable = (props: IconProps) => (
  <SVGUniqueID>{Icon(props)}</SVGUniqueID>
);
export default SvgDataTable;
